import axios from 'axios'
import { transformErrors } from '../utils'

class GlobalStore {
  currentAccount = $state({})
  currentUser = $state({})
  errors = $state([])

  fetchCurrentAccountAndUser() {
    axios.get('/accounts/me.json')
      .then((response) => {
        this.currentAccount = response.data.current_account
        this.currentUser = response.data.current_user
        this.errors = []
      })
      .catch((error) => {
        this.setErrors(error)
      })
  }

  clearErrors() {
    this.errors = []
  }

  setErrors(errors) {
    this.errors = transformErrors(errors)
  }
}

const globalStore = new GlobalStore()
export default globalStore
